<template>
  <div>
    <h5 class="title">
      <span>Eu quero</span>
      {{ group.name }}
    </h5>

    <textarea
      v-model="reason"
      class="form-control mt-2"
      rows="3"
      placeholder="Manda bala, conte pra gente a sua opinião!"
      autofocus
    ></textarea>

    <div
      v-if="!isLogged"
    >
      <PrimaryInput
        v-model="email"
        placeholder="Seu e-mail"
        class="mt-3 mb-0 mb-1"
      />
      <span class="feedback-label">Vamos te avisar por e-mail quando sua sugestão estiver disponível na plataforma! 💪</span>
    </div>

    <div class="d-flex mt-4 justify-content-between align-items-center">
      <SecondaryButton
        :disabled="!isReadyToSubmit"
        class="button"
        @click="submit"
      >Enviar sugestão!</SecondaryButton>

      <button
        class="ml-2 text-secondary"
        @click="back"
      >Voltar</button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SecondaryButton from '@/components/buttons/SecondaryButton'
  import PrimaryInput from '@/components/form/PrimaryInput'

  export default {
    components: {
      SecondaryButton,
      PrimaryInput,
    },

    props: {
      group: { type: Object, required: true }
    },

    mounted () {
      if (this.isLogged) {
        this.email = this.user.email
      }
    },

    data: () => ({
      reason: '',
      email: '',
      hasReason: false,
    }),

    computed: {
      ...mapGetters('user', ['user', 'isLogged']),

      isReadyToSubmit () {
        return this.reason.length > 3 && this.email.includes('@')
      }
    },

    methods: {
      submit () {
        this.$emit('submit', {
          feedback: this.reason,
          group: this.group.name,
          email: this.email,
          isLogged: this.isLogged,
          userId: this.isLogged ? this.user.id : null
        })
      },

      back () {
        this.$emit('back')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .feedback-label {
    font-size: 0.9375rem
  }

  @mixin input-style {
    border-radius: 24px;
    padding: 24px;
    color: $purple50;
    background: $white400;
    border: 3px solid $yellowBorder;
    box-shadow: 0px 4px 8px 2px #12001F, 0px 4px 4px 0px rgba(41, 29, 49, 0.20) inset, 0px 24px 32px -16px rgba(253, 212, 155, 0.25);

    &:focus {
      border: 3px solid $yellowBorder;
    }
  }

  .title {
    @include input-style;

    span {
      display: block;
      font-weight: 300;
      font-size: 1rem;
    }
  }

  textarea {
    @include input-style;
  }
</style>